import { Grid, Typography } from "@mui/material";
import Resumo from "./resumo";
import TabelaDetalhes from "../../util/tabelas/tabelaDetalhes";
import Imposto from "../../../models/imposto";
import { useEffect, useState } from "react";
import { onSnapshot } from "firebase/firestore";
import ImpostoDb from "../../../db/impostoDb";

interface ImpostoTabProp {
  usuarioId: string;
  imposto: Imposto;
}

export default function ImpostoTab({ usuarioId, imposto }: ImpostoTabProp) {
  const [impostoAnterior, setImpostoAnterior] = useState<Imposto>();

  useEffect(() => {
    if (!!usuarioId) {
      return onSnapshot(
        new ImpostoDb().doc({
          usuarioId: usuarioId,
          impostoId: imposto.dataBase
            .clone()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM"),
        }),
        (snapshot) => {
          if (snapshot.exists()) setImpostoAnterior(snapshot.data());
        }
      );
    }
  }, [usuarioId, imposto]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={3}>
        <Resumo
          titulo="Prejuízo acumulado"
          data={impostoAnterior?.dataBase.clone().endOf("month")}
          comuns={impostoAnterior?.abatimentos.operacoesComuns.prejuizo}
          daytrade={impostoAnterior?.abatimentos.operacoesDaytrade.prejuizo}
          fii={impostoAnterior?.abatimentos.operacoesFii.prejuizo}
          total={impostoAnterior?.abatimentos.prejuizo}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <Resumo
          titulo="Resultado"
          data={imposto.dataBase.clone().endOf("month")}
          comuns={imposto?.darf?.operacoesComuns.resultado}
          daytrade={imposto?.darf?.operacoesDaytrade.resultado}
          fii={imposto?.darf?.operacoesFii.resultado}
          total={imposto?.darf?.resultado}
          colorir
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <Resumo
          titulo="Prejuízo acumulado"
          data={imposto.dataBase.clone().endOf("month")}
          comuns={imposto?.abatimentos.operacoesComuns.prejuizo}
          daytrade={imposto?.abatimentos.operacoesDaytrade.prejuizo}
          fii={imposto?.abatimentos.operacoesFii.prejuizo}
          total={imposto?.abatimentos.prejuizo}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <Resumo
          titulo="DARF"
          data={imposto.dataBase.clone().endOf("month")}
          comuns={imposto?.darf?.operacoesComuns.impostoDevido}
          daytrade={imposto?.darf?.operacoesDaytrade.impostoDevido}
          fii={imposto?.darf?.operacoesFii.impostoDevido}
          total={imposto?.darf?.impostoDevido}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="eyebrow" color="text.secondary" mt={2} mb={1}>
          Imposto:
        </Typography>
        <TabelaDetalhes darf={imposto?.darf} />
      </Grid>
    </Grid>
  );
}
